// removed by extract-text-webpack-plugin
module.exports = {"searchContainer":"searchContainer___Q6kft","searchIcon":"searchIcon___leoXg","search":"search___SR41R"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/Search.module.css
// module id = 405
// module chunks = 0